import React from "react";
import ContactUs from "../Components/Common/ContactUs";
import Banner from "../Utils/Banner";

const Contact = () => {
  return (
    <div className="w-full overflow-x-hidden">
      <div
        className="bg-contain bg-no-repeat bg-gray-200 w-full"
        style={{
          backgroundImage: "url('/assets/background.png')",
          backgroundPosition: "right top",
        }}
      >
        <Banner title="Contact Us" />

        <div className="mx-auto max-w-7xl w-full overflow-x-hidden">
          <div className="px-4 sm:px-6 lg:px-8 mt-6 sm:mt-8 mb-10">
            <ContactUs />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
